export default "__VITE_ASSET__BcXM232j__"